import { Dialog, DialogConfig, DialogRef } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/overlay';
import { inject, Injectable } from '@angular/core';
import { DialogStyles, getDialogStyle } from '@shared/services/dialog/configs';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private readonly dialog = inject(Dialog);
  private lastDialogRef?: DialogRef;

  openDialog<T>(
    component: ComponentType<T>,
    style: DialogStyles = 'BIG',
    data: Record<string, unknown> = {}
  ): DialogRef<T> {
    const config: DialogConfig = {
      ...getDialogStyle(style),
      ...data,
    };
    const newDialogRef = this.dialog.open<T>(component, config as DialogConfig<unknown, DialogRef<T>>);

    if (this.lastDialogRef) {
      this.lastDialogRef.close();
    }

    this.lastDialogRef = newDialogRef as DialogRef;
    return newDialogRef;
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }
}
